import React, { useEffect, useRef, useState } from 'react';
import './AnimateOnScroll.css';

function AnimateOnScroll({
  as: Component = 'div',
  className = '',
  children,
  delay = 0,
  threshold = 0.15,
  rootMargin = '0px 0px -10% 0px',
  once = true,
  ...rest
}) {
  const elementRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const element = elementRef.current;

    if (!element) {
      return undefined;
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
      setIsVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);

          if (once) {
            observer.unobserve(entry.target);
          }
        } else if (!once) {
          setIsVisible(false);
        }
      },
      {
        threshold,
        rootMargin
      }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [once, rootMargin, threshold]);

  const combinedClassName = [
    'animate-on-scroll',
    isVisible ? 'animate-on-scroll--visible' : '',
    className
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Component
      ref={elementRef}
      className={combinedClassName}
      style={{ '--reveal-delay': `${delay}ms` }}
      {...rest}
    >
      {children}
    </Component>
  );
}

export default AnimateOnScroll;
